import React, { useContext } from 'react'
import { connect } from 'react-redux'

import type { RootState } from 'store'

import { getCurrentPage } from 'models/location/selectors'
import Footer from 'components/Footer'
import SugarcubeContext from 'apps/SugarcubeContext'

const FooterContainer = ({ location }: { location: string }) => {
    const { isKiosk } = useContext(SugarcubeContext)
    if (
        location !== 'design' &&
        location !== 'signup' &&
        location !== 'login' &&
        location !== 'reset' &&
        location !== 'recover' &&
        !isKiosk
    ) {
        return <Footer location={location} />
    }
    return null
}

const mapStateToProps = (state: RootState) => ({
    location: getCurrentPage(state),
})

export default connect(mapStateToProps)(FooterContainer)
